const BreakpointIndicator = () => {
  if (!import.meta.env.DEV) return null; // solo visible en modo dev

  return (
    <div className="fixed bottom-2 right-2 z-[9999] px-3 py-1 text-xs font-bold text-white bg-black/70 rounded-lg shadow-lg pointer-events-none">
      {/* xs */}
      <span className="block sm:hidden">xs (default)</span>
      {/* sm */}
      <span className="hidden sm:block md:hidden">sm ≥640px</span>
      {/* md */}
      <span className="hidden md:block lg:hidden">md ≥768px</span>
      {/* lg */}
      <span className="hidden lg:block xl:hidden">lg ≥1024px</span>
      {/* xl */}
      <span className="hidden xl:block 2xl:hidden">xl ≥1280px</span>
      {/* 2xl */}
      <span className="hidden 2xl:block">2xl ≥1536px</span>
    </div>
  );
};

export default BreakpointIndicator;
